export default "__VITE_ASSET__cc96ee44__"